<div class="container-fluid main-card">
    <div class="row">
        <div class="col-12">
            <h1>
                {{ favoritesList.title }}
                <span>Organisez vos projets et simulations</span>
            </h1>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-lg-3 col-md-7 col-6 pe-0">
            <mat-form-field class="no-label">
                <mat-select [(ngModel)]="currentList" disableOptionCentering
                            (ngModelChange)="trackingService.click('favorite_list_select_list', currentList);changeList()"
                            class="select-search"
                            placeholder="Mes favoris">
                    <mat-option *ngFor="let list of listFavorite;"
                                value="{{ list.id }}">
                        <ng-container *ngIf="list.share == true">👥 -</ng-container>
                        {{ list.title }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-lg-4 col-md-5 col-6 ps-2 dropdown dropstart text-lg-start text-end">
            <button class="btn btn-outline mobile-icon" id="dropdownEdit"
                    (click)="trackingService.click('favorite_list_edit', currentList)"
                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-ellipsis-v"></i>
                <span>Éditer</span>
            </button>
            <div id="editDropdown" class="dropdown-menu dropdown-menu-left" aria-labelledby="dropdownEdit"
                 aria-haspopup="true"
                 aria-expanded="false">
                <ul class="pictoList">
                    <li>
                        <a (click)="trackingService.click('favorite_list_rename', favoritesList.id);openRenameDialog()">
                            <i class="fa cfa cfa-pencil"></i>
                            Renommer la liste
                        </a>
                    </li>
                    <li>
                        <a (click)="trackingService.click('favorite_list_order', favoritesList.id);orderList()">
                            <i class="fa cfa cfa-sort"></i>
                            Réorganiser vos listes
                        </a>
                    </li>
                    <li *ngIf="user.pro_plan != ''">
                        <a (click)="trackingService.click('favorite_list_share', favoritesList.id);openShareDialog()">
                            <i class="fa fa-share"></i>
                            Partager la liste
                        </a>
                    </li>
                    <li *ngIf="listFavorite.length > 1" class="delete">
                        <a (click)="trackingService.click('favorite_list_delete', favoritesList.id);deleteFavoriteList()">
                            <i class="fa cfa cfa-trash"></i>
                            Supprimer cette liste
                        </a>
                    </li>
                </ul>
            </div>

            <a class="btn btn-outline ms-2 mobile-icon"
               (click)="trackingService.click('favorite_list_new', favoritesList.id);openNewDialog()">
                <i class="fa fa-plus"></i>
                <span>Nouvelle liste</span>
            </a>
        </div>
        <div class="col-lg-5 col-12 text-end hide-mobile">
            <div class="d-inline-block">
                <a class="btn btn-outline mobile-icon"
                   *ngIf="authenticationService.isAllowed('essentiel')"
                   (click)="trackingService.click('favorite_list_compare', favoritesList.id);"
                   [routerLink]="['/app/favorites/compare']"
                   [stepContent]="compareStepContent"
                   joyrideStep="compareStep">
                    <i class="fa fa-table"></i>
                    Comparer mes projets
                </a>

                <button class="btn btn-outline  mobile-icon"
                        *ngIf="!authenticationService.isAllowed('essentiel')"
                        (click)="upgradePlan('assets/upgrade/compare.png', 'Comparaison entre projets', 'Essentiel')">
                    <i class="fa fa-table"></i>
                    <span>Comparer mes projets</span>
                </button>
            </div>

            <a class="btn btn-primary ms-2 ps-4 pe-4  mobile-icon"
               (click)="displaySearchForm()">
                <i class="fa cfa cfa-filter"></i>
                <span>Filtrer</span>
            </a>
        </div>
    </div>
    <div class="row mt-lg-3 mb-lg-3 mt-5">
        <div class="col-lg-6 col-5">
            <h2>
                <ng-container *ngIf="favorites.length > 0">
                    <b class="text-primary">{{ favorites.length | number }}</b> résultats
                </ng-container>
                <ng-container *ngIf="favorites.length == 0 && loading == false">
                    Aucun résultat
                </ng-container>
            </h2>
            <ng-container *ngIf="favoritesList.share == true">
                <ng-container *ngIf="favoritesList.user_id == user.id">
                    Vous êtes le propriétaire de cette liste partagée
                </ng-container>
                <ng-container *ngIf="favoritesList.user_id != user.id">
                    {{ favoritesList.owner_name }} est le propriétaire de cette liste partagée
                </ng-container>
            </ng-container>
        </div>

        <div class="col-3 pe-2">
            <button class="btn btn-outline float-right mobile-icon"
                    (click)="trackingService.click('favorite_list_indicateur', favoritesList.id);displayColumsSelection()"
                    [stepContent]="listDropdownStepContent"
                    [joyrideStep]="'listDropdownStep'"
                    (next)="displayColumsSelection();">
                <i class="fa cfa cfa-sliders"></i>
                <span>Indicateurs</span>
            </button>
        </div>
        <div class="col-lg-3 col-4 ps-0">
            <mat-form-field class="no-label">
                <mat-label>Trier par :</mat-label>
                <mat-select [(ngModel)]="sort" disableOptionCentering
                            (ngModelChange)="trackingService.click('favorite_list_sort', sort);sortFav()"
                            placeholder="Trier par">
                    <mat-option [value]="'add-desc'">Trier par : Date d'enregistrement (Décroissant)</mat-option>
                    <mat-option [value]="'add-asc'">Trier par : Date d'enregistrement (Croissant)</mat-option>
                    <mat-option [value]="'first_publication-desc'">Trier par : Date de publication (Décroissant)
                    </mat-option>
                    <mat-option [value]="'first_publication-asc'">Trier par : Date de publication (Croissant)
                    </mat-option>
                    <mat-option [value]="'price-desc'">Trier par : Prix (Décroissant)</mat-option>
                    <mat-option [value]="'price-asc'">Trier par : Prix (Croissant)</mat-option>
                    <mat-option [value]="'rendement-desc'">Trier par : Rendement (Décroissant)</mat-option>
                    <mat-option [value]="'rendement-asc'">Trier par : Rendement (Croissant)</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="card searchResult selectColumns  mb-4" [hidden]="!columsSelection"
                 [stepContent]="listColumnStepContent"
                 [joyrideStep]="'listColumnStep'"
                 (prev)="displayColumsSelection();">
                <h3>
                    Personnalisation des indicateurs
                    <i (click)="trackingService.click('favorite_list_indicateur_close', favoritesList.id);displayColumsSelection()"
                       class="fa fa-close float-right cursor-pointer"></i>
                </h3>
                <p>Vous pouvez choisir les indicateurs qui seront affichés lors de votre recherche. </p>
                <mat-button-toggle-group class="container-fluid" [multiple]="true" #group="matButtonToggleGroup"
                                         [value]="displayedColumns" (change)="onColChange(group.value)">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-4">
                                <b class="fs-4 mb-2">Informations générales</b>

                                <mat-button-toggle value="ad.square_land">
                                    Surface du terrain
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="lots.length">
                                    Nombre de lots
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="fav.created_at">
                                    Date d'ajout
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad.owner_name">
                                    Nom du contact
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="works_total">
                                    Montant de travaux
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="furniture_price">
                                    Montant des meubles
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="dpe">
                                    DPE
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ges">
                                    GES
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="comment">
                                    Notes
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="liens">
                                    Liens de l'annonce
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>
                            </div>
                            <div class="col-md-4">
                                <b class="fs-4 mb-2">Informations sur la ville</b>

                                <mat-button-toggle value="ad_city.price_diff">
                                    Différence de prix
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.advice_price">
                                    Prix au m²
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.demographie_annuelle">
                                    Population
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="favorite.ad_city.renta">
                                    Rentabilité moyenne
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.carac_commune.mv">
                                    Niveau de vie moy par hab
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.carac_commune.tv">
                                    Taux de logements vacants
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.carac_commune.te">
                                    Taux d'étudiants
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.carac_commune.tc">
                                    Taux de chômage
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.carac_commune.tl">
                                    Taux de locataires
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.logement.anc_loc_ann">
                                    Ancienneté des locataires
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>
                            </div>
                            <div class="col-md-4">
                                <b class="fs-4 mb-2">Informations financières</b>
                                <mat-button-toggle value="efficiency_brut">
                                    Rendement brut
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="efficiency_net">
                                    Rendement net
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="cash_flow">
                                    Cash-flow
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="amount_rent">
                                    Total des loyers
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="charge">
                                    Total des charges
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="amount_property_tax">
                                    Taxe foncière
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="amount_copro">
                                    Charges de copropriété
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="monthly">
                                    Mensualité
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="building_insurance">
                                    Assurance PNO
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="accouting_fees">
                                    Frais de comptabilité
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>
                            </div>
                        </div>
                        <div class="row">
                            <button class="btn btn-primary center"
                                    (click)="trackingService.click('favorite_list_indicateur_valider', favoritesList.id);displayColumsSelection()">
                                Valider
                            </button>
                        </div>
                    </div>
                </mat-button-toggle-group>
            </div>
        </div>
        <div class="col-12">
            <div class="card searchResult selectColumns  mb-4" [hidden]="!search">
                <h3>
                    Filtrer
                    <i (click)="trackingService.click('favorite_list_search_close', favoritesList.id);displaySearchForm()"
                       class="fa fa-close float-right cursor-pointer"></i>
                </h3>
                <p>Rechercher parmi vos favoris de la liste.</p>

                <form [formGroup]="searchForm" class="row">
                    <div class="col-lg-12" id="searchForm" *ngIf="!loading">
                        <div class="row">
                            <div class="col-md-4">
                                <mat-form-field>
                                    <mat-label>Titre</mat-label>
                                    <input formControlName="title" matInput>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field class="filter" floatLabel="never">
                                    <mat-label>Statut</mat-label>
                                    <mat-select disableOptionCentering formControlName="status" multiple
                                                placeholder="Statut">
                                        <mat-option *ngFor="let statu of status"
                                                    value="{{ statu }}">{{ commonService.getStatusLib(statu) }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field class="filter" floatLabel="never">
                                    <mat-label>Ville</mat-label>
                                    <mat-select disableOptionCentering formControlName="ville" multiple
                                                placeholder="Ville">
                                        <mat-option *ngFor="let city of cities"
                                                    value="{{ city.city_code }}">{{ city.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-6 slider-col">
                                <mat-label>Prix</mat-label>
                                <ngx-slider [highValue]="options.ceil" [options]="options" [value]="0"
                                            formControlName="price"></ngx-slider>
                            </div>
                            <div class="col-md-6 slider-col">
                                <mat-label>Rendement BRUT</mat-label>
                                <ngx-slider [highValue]="optionsRendement.ceil" [options]="optionsRendement"
                                            [value]="0"
                                            formControlName="rendement"></ngx-slider>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <ng-container *ngFor="let favorite of favorites; index as i;">
            <div class="col-12 mb-4">
                <div class="card searchResult">
                    <div class="card-body card-{{ favorite.ad.ai_id }}">
                        <div class="container-fluid">
                            <div class="mainRow row">
                                <div class="titleInfo">
                                    <app-status [favorite]="favorite" class="me-md-5 float-left float-md-end list"></app-status>
                                    <b class="fs-3 w-100">{{ favorite.title }}</b>
                                    <div class="col-12 iconeInfo">
                                        <div class="ms-2 dropdown dropstart">
                                            <button class="icone bg-white" id="dropdownEdit-{{i}}"
                                                    data-bs-toggle="dropdown"
                                                    aria-haspopup="true" aria-expanded="false"
                                                    (click)="trackingService.click('favorite_list_option_favorite', favorite.id);"
                                                    [stepContent]="favListLastInfoStepContent"
                                                    [joyrideStep]="'favListLastInfoStep' + i">
                                                <i class="fa fa-ellipsis-v"></i>
                                            </button>
                                            <div id="editDropdown-{{i}}" class="dropdown-menu dropdown-menu-right"
                                                 aria-labelledby="dropdownEdit"
                                                 aria-haspopup="true" aria-expanded="false">
                                                <ul class="pictoList">
                                                    <li>
                                                        <a (click)="trackingService.click('favorite_list_favorite_move', favorite.id);moveFavorite(favorite)">
                                                            <i class="fa fa-arrows-h"></i>
                                                            Déplacer ce favoris
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a (click)="trackingService.click('favorite_list_favorite_notes', favorite.id);noteFavorite(favorite)">
                                                            <i class="fa fa-sticky-note-o"></i>
                                                            Modifier mes notes
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a (click)="trackingService.click('favorite_list_favorite_compare', favorite.id);compareAdd(favorite)">
                                                            <i class="fa fa-table"></i>
                                                            Ajouter au comparateur
                                                        </a>
                                                    </li>
                                                    <li class="delete">
                                                        <a (click)="trackingService.click('favorite_list_favorite_delete', favorite.id);deleteFavorite(favorite)">
                                                            <i class="fa cfa cfa-trash"></i>
                                                            Supprimer
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="wrapImg me-2 mb-lg-0 mb-2">
                                    <img *ngIf="favorite.pictures.length == 0" src="assets/no-photo.png" alt=""/>
                                    <div *ngIf="favorite.pictures.length > 0" id="picturesCarousel{{favorite.ad.ai_id}}"
                                         class="carousel slide" data-ride="carousel">
                                        <div class="carousel-inner">
                                            <div *ngFor="let picture of favorite.pictures; index as ig;"
                                                 [ngClass]="{'carousel-item': true, 'active': ig == 0}"
                                                 [ngStyle]="{ 'background-image': 'url(' + picture + ')'}">
                                                <img *ngIf="picture" style="display: none;" src="{{ picture }}">
                                            </div>
                                        </div>
                                        <button *ngIf="favorite.pictures.length > 1" class="carousel-control-prev"
                                                type="button"
                                                [attr.data-bs-target]="'#picturesCarousel' + favorite.ad.ai_id"
                                                data-bs-slide="prev">
                                            <i class="fa fa-chevron-left"
                                               (click)="trackingService.click('favorite_list_image_prev', favorite.id);"></i>
                                            <span class="visually-hidden">Previous</span>
                                        </button>
                                        <button *ngIf="favorite.pictures.length > 1" class="carousel-control-next"
                                                type="button"
                                                [attr.data-bs-target]="'#picturesCarousel' + favorite.ad.ai_id"
                                                data-bs-slide="next">
                                            <i class="fa fa-chevron-right"
                                               (click)="trackingService.click('favorite_list_image_next', favorite.id);"></i>
                                            <span class="visually-hidden">Next</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="mainInfo me-lg-2 mb-lg-0 mb-2"
                                     [stepContent]="favListInfoStepContent"
                                     [joyrideStep]="'favListInfoStep' + i">
                                    <b class="price text-primary fs-2 price">
                                        {{ favorite.price | number: '1.0-0' }} €
                                    </b>
                                    <b class="squarePrice text-secondary d-block">
                                        {{ (favorite.price / favorite.square) | number: '1.0-0' }} €/m²
                                    </b>
                                    <b class="estateType mt-2 fs-4 d-block">
                                        {{ favorite.ad.real_estate_type }}
                                        <ng-container *ngIf="!favorite.ad.real_estate_type"><br/></ng-container>
                                    </b>

                                    <b class="squareRoom text-secondary d-block">
                                        <ng-container *ngIf="favorite.square > 0">
                                            {{ favorite.square | number: '1.0-0' }} m²
                                        </ng-container>
                                        <ng-container *ngIf="favorite.square > 0 && favorite.ad.rooms > 0">
                                            -
                                        </ng-container>
                                        <ng-container *ngIf="favorite.ad.rooms > 0">
                                            {{ favorite.ad.rooms }} pièces
                                        </ng-container>
                                    </b>

                                    <span class="fpb text-secondary d-block mt-2 fs-small">
                                    <i class="fa cfa cfa-calendar"
                                       *ngIf="favorite.ad.first_publication_date"></i> {{ favorite.ad.first_publication_date }}
                                        <ng-container *ngIf="!favorite.ad.first_publication_date"><br/></ng-container>
                                </span>

                                    <p>
                                        <a class="mt-2 btn btn-primary btn-sm d-block"
                                           (click)="trackingService.click('favorite_list_open_favorite', favorite.id);"
                                           [routerLink]="['/app/favorites', favoritesList.id, favorite.id]">
                                            Ouvrir
                                        </a>
                                    </p>
                                </div>
                                <div class="kpiInfo pe-3 ps-3 col-xxl-6 col-xl-6 col-lg-5"
                                     [stepContent]="favListKPIStepContent"
                                     [joyrideStep]="'favListKPIStep' + i">
                                    <div class="row">
                                        <div class="col-12 iconeInfo">
                                            <div class="icone"
                                                 *ngIf="favorite.comment != ''  && favorite.id != ''">
                                                <i matTooltip="{{ favorite.comment }}"
                                                   (click)="trackingService.click('favorite_list_favorite_notes_ico', favorite.id);noteFavorite(favorite)"
                                                   class="fa fa-sticky-note-o text-grey ad_category" type="button"></i>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.price_change">
                                                <p class="svg baisse-prix" matTooltip="Baisse de prix"></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.work">
                                                <p matTooltip="Travaux à prévoir" class="svg work"></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.rent">
                                                <p class="svg rent-result" matTooltip="Locataire en place"></p>
                                            </div>
                                            <div class="icone"
                                                 *ngIf="favorite.ad.adress != '' && favorite.ad.adress != '-'">
                                                <p class="svg adress" matTooltip="Adresse du bien enregistrée"></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.bad_location">
                                                <p class="svg bad_city"
                                                   matTooltip="La ville renseignée semble incorrecte"></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.category == 'Viager'">
                                                <p class="svg viager" matTooltip="Le bien est vendu en viager."></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.category == 'Enchere'">
                                                <p class="svg enchere" matTooltip="Le bien est vendu aux enchères."></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.has_local_commercial">
                                                <p class="svg commerce"
                                                   matTooltip="Le lot comprend un local commercial"></p>
                                            </div>
                                            <div class="icone" *ngIf="!adService.isSquareValid(favorite)">
                                                <p class="svg bad_square"
                                                   matTooltip="La surface du bien semble incorrect"></p>
                                            </div>
                                        </div>
                                        <div class="col-12 fs-small city ps-0 ps-md-2">
                                            <i class="cfa cfa-pin"></i>
                                            <span class="text-primary me-3" *ngIf="favorite.ad_city.name != ''">
                                                {{ favorite.ad_city.name }}
                                                ({{ favorite.ad_city.zip_code }})
                                            </span>
                                            <ng-container *ngIf="favorite.ad.urls && favorite.ad.urls.length > 0">
                                                <i class="fa fa-flag me-2"></i>
                                                {{ adService.getProviderLib(favorite.ad.urls[adService.findSmallLink(favorite.ad)].provider) }}
                                            </ng-container>
                                            <ng-container *ngIf="favorite.ad.urls && favorite.ad.urls.length > 1">
                                                +{{ favorite.ad.urls.length - 1 }} autres
                                            </ng-container>
                                        </div>
                                        <div class="col-12 dataInfo mt-md-4">
                                            <div class="row">
                                                <ng-container *ngFor="let dc of displayedColumns; index as idc;">
                                                    <div class="kpi-value kpi-blank"
                                                         *ngIf="idc == 4 && (displayedColumns.length == 7 || displayedColumns.length == 8)"></div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.price_diff'">
                                                        <label>Différence
                                                            <i class="fa fa-question-circle"
                                                               matTooltip="Comparaison avec {{ cityService.getFullLib(favorite.advice_price_real, favorite.ad_city, favorite.iris) }}"></i>
                                                        </label>
                                                        <p [ngClass]="{'value': true, 'text-green' : favorite.price / favorite.square < favorite.advice_price, 'text-red' : favorite.price / favorite.square > favorite.advice_price}">
                                                            <ng-container *ngIf="favorite.advice_price > 0">
                                                                {{ ((favorite.price / favorite.square) / favorite.advice_price * 100) - 100 | number:'1.0-0' }}
                                                                %
                                                            </ng-container>
                                                            <ng-container *ngIf="favorite.advice_price == 0">-
                                                            </ng-container>
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.demographie_annuelle'">
                                                        <label>Nb. d'habitants</label>
                                                        <p [ngClass]="{'value': true, 'text-green' : favorite.ad_city.demographie_annuelle.Cr == 1, 'text-red' : favorite.ad_city.demographie_annuelle.Cr == -1}">
                                                            {{ favorite.ad_city.demographie_annuelle[EVOL_DEMO_LAST_YEAR] | number: '1.0-0' }}
                                                            <i *ngIf="favorite.ad_city.demographie_annuelle.Cr == 1"
                                                               matTooltipClass="tooltip-button"
                                                               matTooltip="Démographie en hausse"
                                                               class="fa fa-arrow-up"></i>
                                                            <i *ngIf="favorite.ad_city.demographie_annuelle.Cr == 0"
                                                               matTooltipClass="tooltip-button"
                                                               matTooltip="Démographie stable"
                                                               class="fa fa-arrow-right"></i>
                                                            <i *ngIf="favorite.ad_city.demographie_annuelle.Cr == -1"
                                                               matTooltipClass="tooltip-button"
                                                               matTooltip="Démographie en baisse"
                                                               class="fa fa-arrow-down"></i>
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.carac_commune.mv'">
                                                        <label>Niv. de vie/hab</label>
                                                        <p class="value">
                                                            {{ favorite.ad_city.carac_commune.MED_NV | number: '1.0-0' }}
                                                            €
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'favorite.ad_city.renta'">
                                                        <label>Rend. ville
                                                            <i class="fa fa-question-circle"
                                                               matTooltipClass="tooltip-button"
                                                               matTooltip="Rendement moyen dans la ville (tous types de biens confondus et sans prise en compte des travaux)."></i>
                                                        </label>
                                                        <p class="value">
                                                            {{ favorite.ad_city.renta["R"] * 100| number: '1.0-1' }} %
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.carac_commune.te'">
                                                        <label>Étudiants</label>
                                                        <p [ngClass]="{'value': true, 'text-green' : favorite.ad_city.carac_commune.T_etud >= 0.12 , 'text-red' : favorite.ad_city.carac_commune.T_etud <= 0.08}">
                                                            {{ favorite.ad_city.carac_commune.T_etud * 100 | number: '1.1-1' }}
                                                            %
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.advice_price'">
                                                        <label>Prix au m²
                                                            <i class="fa fa-question-circle"
                                                               matTooltip="Moyenne pour {{ cityService.getFullLib(favorite.advice_price_real, favorite.ad_city, favorite.iris) }}"></i>
                                                        </label>
                                                        <p class="value">
                                                                        <span
                                                                            *ngIf="favorite.advice_price != 0">{{ favorite.advice_price | number:'1.0-0' }}</span>
                                                            <span *ngIf="favorite.advice_price == 0">-</span> €/m²
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'amount_rent'">
                                                        <label>Loyer total</label>
                                                        <p class="value">
                                                            {{ favorite.amount_rent | number: '1.0-0' }}  €/mois
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.carac_commune.tc'">
                                                        <label>Chômage</label>
                                                        <p [ngClass]="{'value': true, 'text-green' : favorite.ad_city.carac_commune.T_chom < 0.075 , 'text-red' : favorite.ad_city.carac_commune.T_chom >= 0.13}">
                                                            {{ favorite.ad_city.carac_commune.T_chom * 100 | number: '1.1-1' }}
                                                            %
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'ad.square_land'">
                                                        <label>Surface terrain</label>
                                                        <p class="value">
                                                            {{ favorite.ad.square_land }} m²
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'lots.length'">
                                                        <label>Nombre de lots</label>
                                                        <p class="value">
                                                            {{ favorite.nb_lots }}
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'fav.created_at'">
                                                        <label>Date de création</label>
                                                        <p class="value text">
                                                            {{ favorite.created_at | date:'short' }}
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'ad.owner_name'">
                                                        <label>Contact</label>
                                                        <p class="value text">
                                                            {{ favorite.ad.owner_name | slice:0:15 }}
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'works_total'">
                                                        <label>Travaux</label>
                                                        <p class="value">
                                                            {{ favorite.works_total + favorite.other_fees_work | number: '1.0-0' }}
                                                            €
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'furniture_price'">
                                                        <label>Meubles</label>
                                                        <p class="value">
                                                            {{ favorite.furniture_price | number: '1.0-0' }} €
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'dpe'">
                                                        <label>DPE</label>
                                                        <app-dpe [favorite]="favorite"></app-dpe>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'ges'">
                                                        <label>GES</label>
                                                        <app-ges [favorite]="favorite"></app-ges>
                                                    </div>

                                                    <div class="kpi-value double_row" *ngIf="dc == 'comment'">
                                                        <label>Notes</label>
                                                        <p class="value text">
                                                            {{ favorite.comment | slice:0:100 }}
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'liens'">
                                                        <label>Liens</label>
                                                        <div class="value value-link" *ngIf="favorite.ad.urls">
                                                            <a [ngClass]="'btn btn-'+favorite.ad.urls[adService.findSmallLink(favorite.ad)].provider+' btn-sm'"
                                                               *ngIf="favorite.ad.urls.length > 0 && adService.getProviderLib(favorite.ad.urls[adService.findSmallLink(favorite.ad)].provider) != 'Site partenaire'"
                                                               href="{{ favorite.ad.urls[adService.findSmallLink(favorite.ad)].url }}"
                                                               target="_blank">
                                                                {{ adService.getProviderLib(favorite.ad.urls[adService.findSmallLink(favorite.ad)].provider) }}
                                                            </a>

                                                            <a [ngClass]="'btn btn-'+favorite.ad.urls[adService.findSmallLink(favorite.ad)].provider+' btn-sm'"
                                                               *ngIf="favorite.ad.urls.length > 0 && adService.getProviderLib(favorite.ad.urls[adService.findSmallLink(favorite.ad)].provider) == 'Site partenaire'">
                                                                Site partenaire
                                                            </a>
                                                        </div>
                                                    </div>

                                                    <!-- Ville -->

                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.carac_commune.tv'">
                                                        <label>Logements vacants</label>
                                                        <p class="value">
                                                            {{ favorite.ad_city.logement.T_LV * 100 | number: '1.1-1' }}
                                                            %
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.carac_commune.tl'">
                                                        <label>Taux de locataires</label>
                                                        <p class="value">
                                                            {{ favorite.ad_city.carac_commune.T_LOC * 100 | number: '1.1-1' }}
                                                            %
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.logement.anc_loc_ann'">
                                                        <label>Ancienneté des locataires</label>
                                                        <p class="value">
                                                            {{ favorite.ad_city.logement.anc_loc_ann | number: '1.1-1' }}
                                                            ans
                                                        </p>
                                                    </div>

                                                    <!-- Finance -->
                                                    <div class="kpi-value"
                                                         *ngIf="dc == 'efficiency_brut'">
                                                        <label>Rendement brut</label>
                                                        <p class="value">
                                                            {{ favorite.efficiency_brut | number: '1.1-1' }} %
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value"
                                                         *ngIf="dc == 'efficiency_net'">
                                                        <label>Rendement net</label>
                                                        <p class="value">
                                                            {{ favorite.efficiency_net | number: '1.1-1' }} %
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value"
                                                         *ngIf="dc == 'cash_flow'">
                                                        <label>Cash flow</label>
                                                        <p [ngClass]="{'value': true, 'text-green' : favorite.cash_flow >= 0, 'text-red' : favorite.cash_flow < 0}">
                                                            {{ favorite.cash_flow | number: '1.0-0' }} €
                                                        </p>
                                                    </div>


                                                    <div class="kpi-value" *ngIf="dc == 'charge'">
                                                        <label>Charges</label>
                                                        <p class="value">
                                                            {{ favorite.charge | number: '1.0-0' }} €
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'amount_property_tax'">
                                                        <label>Taxe foncière</label>
                                                        <p class="value">
                                                            {{ favorite.amount_property_tax | number: '1.0-0' }} €
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'amount_copro'">
                                                        <label>Charges de copro</label>
                                                        <p class="value">
                                                            {{ favorite.amount_copro | number: '1.0-0' }} €
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'monthly'">
                                                        <label>Mensualité</label>
                                                        <p class="value">
                                                            {{ favorite.monthly | number: '1.0-0' }} €
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value"
                                                         *ngIf="dc == 'building_insurance'">
                                                        <label>PNO</label>
                                                        <p class="value">
                                                            {{ favorite.building_insurance | number: '1.0-0' }} €
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value"
                                                         *ngIf="dc == 'accouting_fees'">
                                                        <label>Compta</label>
                                                        <p class="value">
                                                            {{ favorite.accouting_fees | number: '1.0-0' }} €
                                                        </p>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="lastInfo">
                                    <div class="wrap p-3">
                                        <div class="col-4 col-lg-12 mb-lg-3">
                                            <label class="fs-small d-block">Cash flow / mois</label>
                                            <b class="text-primary fs-4">
                                                <span
                                                    *ngIf="favorite.amount_rent != 0">{{ favorite.cash_flow  | number: '1.0-0' }}</span>
                                                <span *ngIf="favorite.amount_rent == 0">- </span> €
                                            </b>
                                        </div>
                                        <div class="col-4 col-lg-12 mb-lg-3">
                                            <label class="fs-small d-block">Rendement brut</label>
                                            <b class="text-primary fs-4">
                                                <span
                                                    *ngIf="favorite.efficiency_brut != 0">{{ favorite.efficiency_brut  | number: '1.1-1' }}</span>
                                                <span *ngIf="favorite.efficiency_brut == 0">- </span> %
                                            </b>
                                        </div>
                                        <div class="col-4 col-lg-12 mb-lg-3">
                                            <label class="fs-small d-block">Rendement net</label>
                                            <b class="text-primary fs-4">
                                            <span
                                                *ngIf="favorite.efficiency_net != 0">{{ favorite.efficiency_net  | number: '1.1-1' }}</span>
                                                <span *ngIf="favorite.efficiency_net == 0">- </span> %
                                            </b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <div class="col-12 mb-4" [hidden]="favorites.length > 0 || loading == true">
            <div class="card searchResult">
                <div>
                    <b class="title text-center d-block mt-3 fs-3 mb-3">
                        Aucun favoris dans cette liste<br/>
                    </b>
                    <p class="text-center">
                        Vous pouvez enregistrer des annonces en favoris depuis notre moteur de recherche ou importer
                        votre projet (biens off market par exemple).
                    </p>
                    <div class="row">
                        <div class="offset-3 col-3 mt-4 mb-3">
                            <a class="btn btn-outline d-block"
                               (click)="trackingService.click('favorite_list_empty_import', favoritesList.id);"
                               [routerLink]="['/app/tools/new']">
                                Importer mon projet
                            </a>
                        </div>
                        <div class="col-3 mt-4 mb-3">
                            <a class="btn d-block"
                               (click)="trackingService.click('favorite_list_empty_search', favoritesList.id);"
                               [routerLink]="['/app/search']">
                                Lancer une recherche
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12" [hidden]="!loading">
            <div class="card card-loading">
                <div class="card-body">
                    <mat-spinner color="second"></mat-spinner>
                </div>
            </div>
        </div>


    </div>
</div>

<!-- Onboarding -->
<joyrideStep [stepContent]="introStepContent"
             joyrideStep="introStep"
             stepPosition="center">
</joyrideStep>
<ng-template #introStepContent>
    <div class="user_onboarding_content">
        <h2>Bienvenue dans vos annonces favorites</h2>
        <p>
            Dans ce menu, vous allez pouvoir <b>organiser toutes vos annonces enregistrées</b>.<br/>
            <br/>
            Les informations clés sont visibles pour vous souvenir rapidement pourquoi le projet était intéressant<br/>
            <br/>
            Ces informations sont séparées en <b>3 parties</b>, faisons le tour ensemble !
        </p>
    </div>
</ng-template>

<ng-template #favListInfoStepContent>
    <div class="user_onboarding_content">
        <h2>1ère partie : La base</h2>
        <p>
            Vous retrouverez ici les <b>informations de base</b> de l’annonce et le liens pour ouvrir le détail de votre
            analyse.
        </p>
    </div>
</ng-template>

<ng-template #favListKPIStepContent>
    <div class="user_onboarding_content">
        <h2>2ème partie : Les données avancées</h2>
        <p>
            Sur chaque annonce, vous retrouverez les <b>informations importantes</b><br/>
            <br/>
            Vous pouvez cliquer sur le menu déroulant pour définir le “statut” de ce favoris : “Analyse
            en cours”, “A contacter”, “A visiter” …<br/>
            <br/>
            Idéal pour suivre facilement l’avancement de chaque projet !
            <b>Astuce</b> : Vous pouvez choisir les indicateurs à afficher ! On voit ça juste après 😉
            <br/>
        </p>
    </div>
</ng-template>

<ng-template #favListLastInfoStepContent>
    <div class="user_onboarding_content">
        <h2>3ème partie : Gestion de votre favoris</h2>
        <p>
            Pour retourner dans la simulation, supprimer votre favori, ou bien le comparer à d’autres favoris, c’est
            ici.
        </p>
    </div>
</ng-template>

<ng-template #listDropdownStepContent>
    <div class="user_onboarding_content">
        <h2>Les options avancées</h2>
        <p>
            En cliquant ici, vous pourrez <b>choisir les indicateurs</b> à afficher sur chaque annonce.<br/>
            <br/>
            Et oui, c’est <b>maintenant</b> !
        </p>
    </div>
</ng-template>

<ng-template #listColumnStepContent>
    <div class="user_onboarding_content">
        <h2>Les options avancées</h2>
        <p>
            Vous avez accès à différents indicateurs sur l’annonce, la ville, ou bien les <b>chiffres financiers</b> du
            projet.<br/>
            <br/>
            Cliquez simplement sur les cases qui vous intéressent pour ajouter/supprimer des indicateurs, puis cliquez
            sur la croix en haut à droite.<br/>
            <br/>
            <b>Facile, non ?</b>
        </p>
    </div>
</ng-template>

<ng-template #compareStepContent>
    <div class="user_onboarding_content">
        <h2>Bienvenue dans la comparaison de projets</h2>
        <p>
            Vous avez plusieurs annonces qui vous intéressent mais vous ne savez pas laquelle est la plus intéressante ?<br/>
            <br/>
            <b>Faisons ensemble une comparaison de ces annonces !</b><br/>
            <br/>
            <b>Astuce</b> : Vous pouvez aussi comparer plusieurs scénarios sur un même projet (avec ou sans travaux,
            avec division ou non …)<br/>
            <br/>
            Pour cela, rendez-vous dans votre favori puis dupliquez le (engrenage en haut à droite). <b>Vous pourrez
            ensuite comparer les 2 scénarios entre eux</b>.
        </p>
    </div>
</ng-template>
